<template>
    <v-dialog
        v-model="activate"
        max-width="900px"
        persistent
    >
        <v-card class="px-4" color="background">
            <v-card-title>
            <vuse-section-definition
                :title="formTitle"
                icon="mdi-lightbulb-group"
                class="ml-n4 pa-0 pb-4" />
            </v-card-title>
            <v-card-text>
                <v-container fluid class="fill-width">
                <v-form ref="groupForm">
                <v-sheet class="neu-glow with-radius">
                <v-row>
                  <v-col cols="12" md="4">
                      <v-text-field
                          v-model="editedItem.groupName"
                          @input="validate"
                          :label="$t('Global.Groups.groupName')+'*'"
                          :rules="[ requiredRule ]"
                          counter="50"
                          required
                          clearable
                          style="padding: 12px"
                      ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                <v-col class="col-md-5" style="padding-left: 25px">
                  <v-card
                    max-width="300"
                  >
                    <v-list>
                      <v-virtual-scroll
                        :items="nodes"
                        :item-height="48"
                        height="500"
                      >
                        <template v-slot="{ item }">
                          <v-list-item-group v-model="nodeSelected">
                            <v-list-item :key="item.name" :value="item" >
                              <v-list-item-content>
                                <v-list-item-title>{{getNodeDesc(item) + ": " + item.nodeExtension + " - " + item.nodeName}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </template>
                      </v-virtual-scroll>
                    </v-list>
                  </v-card>
                  </v-col>

                  <v-col class="col-md-2 align-self-center">
                  <v-row style="margin-bottom: 20px; margin-left: auto; margin-right: auto;">
                  <v-btn color="primary" @click="addNode">{{"Añadir &gt;&gt;"}}</v-btn>
                  </v-row>
                  <v-row style="margin-top: 20px; margin-left: auto; margin-right: auto;">
                  <v-btn color="primary" @click="removeNode">{{"&lt;&lt; Quitar"}}</v-btn>
                  </v-row>
                  </v-col>

                  <v-col class="col-md-5">
                  <v-card
                    max-width="300"
                  >
                    <v-list>
                      <v-virtual-scroll
                        :items="groupNodes"
                        :item-height="48"
                        height="500"
                      >
                        <template v-slot="{ item }">
                          <v-list-item-group v-model="groupNodeSelected">
                            <v-list-item :key="item.nodeName" :value="item" >
                              <v-list-item-content>
                                <v-list-item-title>{{getNodeDesc(item) + ": " + item.nodeExtension + " - " + item.nodeName}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </template>
                      </v-virtual-scroll>
                    </v-list>
                  </v-card>
                  </v-col>
                  </v-row>
                  
                </v-sheet>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('Global.Nodes.cancel') }}</v-btn>
            <v-btn color="blue darken-1" text @click="submitItem" :disabled="!validForm">{{ $t('Global.Nodes.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Utils from "@/mixins/Utils";
import {mapGetters} from "vuex";
import ROL from "@/config/rol-values";
import NodeApi from "@/mixins/Services/NodeApi";
import GroupApi from "@/mixins/Services/GroupApi";

export default {
    name: "NodesDialog",
    mixins: [Utils, NodeApi, GroupApi],
    props: {
        activate: {
            type: Boolean,
            default: false,
            required: true
        },
        isViewSuper: {
            type: Boolean,
            default: false,
            required: true
        },
        item: {
            type: Object,
            default: null
        }
    },
  data() {
    return {
      editedItem: {
        groupId: null,
        groupName: "",
        groupNodes: []
      },
      defaultItem:{
        groupId: null,
        groupName: "",
        groupNodes: []
      },
      nodes: [],
      groupNodes: [],
      headers: [
        { text: this.$t('Global.Nodes.name'), value: "name", align: "left", sortable: true}
      ],
      nodeSelected: null,
      groupNodeSelected: null,

      requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
      validForm: false,
      rol: ROL,
    }
  },
    computed: {
      ...mapGetters(['getDefsRolesTypes', 'getRoleId', 'getDefsNodeTypes']),
      getHeaders() {
      if (this.headers.length) {
         return this.headers
      }
      else return []
    },
        formTitle() {
            return !this.item ? this.$t('Global.Groups.newGroup') : this.$t('Global.Groups.editGroup');
        },
      isRolSuper(){
        return [this.rol.SUPER_ADMIN, this.rol.SUPER_USER].includes(this.getRoleId)
      },
      getRolesEnableds(){
        return this.getDefsRolesTypes
            .filter((f)=> this.isRolSuper && this.isViewSuper
                ? [this.rol.SUPER_ADMIN, this.rol.SUPER_USER].includes(f.roleId)
                : [this.rol.SITE_ADMIN, this.rol.SITE_USER, this.rol.DISPLAY_USER].includes(f.roleId) )
      }
    },
    methods: {
        validate() {
            this.validForm = this.$refs.groupForm.validate() && this.groupNodes.length !== 0
        },
        closeDialog() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.$emit('close-dialog')
        },
        addNode() {
            if(this.nodeSelected===null) return;
            var parseNodes = JSON.parse(JSON.stringify(this.nodes))
            var parseNodesIds = []

            parseNodes.forEach(node => {
              parseNodesIds.push(node.nodeId); 
            })
            var parseNodeSelected = JSON.parse(JSON.stringify(this.nodeSelected))
            var index = parseNodesIds.indexOf(parseNodeSelected.nodeId)
    
            if (index !== -1) {
              this.nodes.splice(index, 1)
              this.groupNodes.push(parseNodeSelected)
              this.nodeSelected=null
              this.validForm = this.groupNodes.length !== 0
            }  
        },
        removeNode() {
            if(this.groupNodeSelected===null) return;
            var parseGroupNodes = JSON.parse(JSON.stringify(this.groupNodes))
            var parseGroupNodesIds = []
            parseGroupNodes.forEach(groupNode => {
              parseGroupNodesIds.push(groupNode.nodeId); 
            })
            var parseGroupNodeSelected = JSON.parse(JSON.stringify(this.groupNodeSelected))
            var index = parseGroupNodesIds.indexOf(parseGroupNodeSelected.nodeId)
    
            if (index !== -1) {
              this.groupNodes.splice(index, 1)
              this.nodes.push(parseGroupNodeSelected)
              this.groupNodeSelected=null
              this.validForm = this.groupNodes.length !== 0
            }  
        },
        submitItem() {
            this.editedItem.groupNodes = this.groupNodes
            for (const prop in this.editedItem ) {
                if (this.editedItem[prop] === null) this.editedItem[prop] = ""
            }
            if (this.item)
                this.$emit('update-item', this.editedItem)
            else
                this.$emit('create-item', this.editedItem)
            this.closeDialog()
        },
      getRoleType(item) {
        return this.getDefsRolesTypes.find((e) => e.roleId === item.roleId)?.roleName
      },
      getNodeDesc(item) {
        var nodeType = this.getDefsNodeTypes?.find((e) => e.nodeTypeId === item.nodeTypeId)?.nodeTypeDesc

        if(nodeType === 'Agent'){
          return this.$t('Global.Groups.nodeAgent')
        }
        else if(nodeType === 'Basic'){
          return this.$t('Global.Groups.nodeExtension')
        }
        else if(nodeType === 'CallcenterPremium'){
          return this.$t('Global.Groups.nodeQueue')
        }
        else{
          return nodeType
        }
      },
      async getNodesList() {
      try{
        this.setLoader(true)
          if(this.editedItem.groupId!==null){
            var nodesList = await this.getAvalaibleNodesForGroup(this.editedItem.groupId)
          }
          else{
            nodesList = await this.getAvalaibleNodes()
          }  
          
          // Se excluyen los nodos de tipo cola para los grupos
          this.nodes = nodesList?.filter((n) => n.nodeTypeId !== 2)

        this.setLoader(false)
        } catch (e) {
          this.nodes = []
          console.error('[NODES][getNodes] ERROR:', e)
          this.setLoader(false)
          if(this.isErrorText(e)){
            const errorCode = this.getErrorText(e);
            this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
          }
        }
      },
      async getGroupNodeList() {
      try{
        this.setLoader(true)
        this.groupNodes = await this.getNodesByGroup(this.editedItem.groupId); 
        this.setLoader(false)
        } catch (e) {
          this.nodes = []
          console.error('[groups][getNodesByGroup] ERROR:', e)
          this.setLoader(false)
          if(this.isErrorText(e)){
            const errorCode = this.getErrorText(e);
            this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
          }
        }
      }
    },
    mounted(){
      if (this.item) {
        this.editedItem = Object.assign({}, this.item)
        this.getGroupNodeList()
      } else {
        this.defaultItem['companyId'] = this.loadCompanyId()
        this.editedItem = Object.assign({}, this.defaultItem)
      }
      this.getNodesList()
    }
}
</script>

